/**
 * Types of removable chips created from autocomplete fields in EditableLabel
 */
export function AutocompleteChipsTypes() {}
AutocompleteChipsTypes.USER = 1;
AutocompleteChipsTypes.ZONE = 2;
AutocompleteChipsTypes.KEYWORD = 3;

AutocompleteChipsTypes.ALL_TYPES = [
  AutocompleteChipsTypes.USER,
  AutocompleteChipsTypes.ZONE,
  AutocompleteChipsTypes.KEYWORD,
];

export default {
  AutocompleteChipsTypes,
};
